'use strict';
//Jquery
import $ from "jquery";

//Bootstrap
import Bootstrap from 'bootstrap';
import "bootstrap/dist/css/bootstrap.css";

//Slick slider
import SlickSlider from 'slick-slider';
import "slick-slider/slick/slick.css";

//moment
import moment from 'moment';
moment.locale('lt');

//pikaday
import Pikaday from 'pikaday';
import "pikaday/css/pikaday.css";

//tooltipster
import Tooltipster from 'tooltipster';
import "tooltipster/dist/css/tooltipster.bundle.css";

//fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

//mmenu-light
import mmenuLight from 'mmenu-light';
import "mmenu-light/dist/mmenu-light.css";

$(document).ready(function () {
	if (!$("#popup_window").length) {
		fancybox();
		pikaday();
		tooltipster();
		fixedHeader();
		equalHeight();
		slickSlider();
		searchToggle();
		initEuCookieSettings();
		mobileMenuInsideToggler();
		dragAndDropFiles();
		toggler();
		equalHeightNew();
		dukToggle();
	}
});

$(window).on('load', function () {
	$("body").removeClass("preload");
});

document.addEventListener("DOMContentLoaded", () => {
	const menu = new MmenuLight(
			document.querySelector("#menu"),
			"(max-width: 1024px)"
			);

	const navigator = menu.navigation();
	const drawer = menu.offcanvas({
		position: "left", // Slide from the top
		page: {
			selector: "#page"
		}
	});

	let menuOpen = false;

	document.querySelector("a[href='#menu']").addEventListener("click", (evnt) => {
		evnt.preventDefault();
		if (!menuOpen) {
			drawer.open();
			document.querySelector('.mobile-header').classList.add('active');
		} else {
			drawer.close();
			document.querySelector('.mobile-header').classList.remove('active');
		}
		menuOpen = !menuOpen; // Toggle the menu state
	});

});

function fancybox() {
	Fancybox.bind('[data-fancybox="gallery"]', {

	});
	Fancybox.bind('[data-fancybox]', {
		autoStart: false,
	});
}

function equalHeightNew() {
	// Find all elements with the meta-adjust class
	var metaElements = $('.meta-adjust');

	// Find the maximum height among the meta elements
	var maxHeight = 0;
	metaElements.each(function () {
		var elementHeight = $(this).height();
		if (elementHeight > maxHeight) {
			maxHeight = elementHeight;
		}
	});

	// Set the maximum height to all meta elements
	metaElements.height(maxHeight);
}
function pikaday() {
	const datePickerElements = document.querySelectorAll('.datepicker');
	datePickerElements.forEach(datePickerElement => {
		const today = new Date();
		const formattedDate = moment(today).format('YYYY-MM-DD');

		datePickerElement.value = formattedDate;

		new Pikaday({
			field: datePickerElement,
			format: 'YYYY-MM-DD',
			showDaysInNextAndPreviousMonths: true,
			toString(date) {
				return moment(date).format('YYYY-MM-DD');
			},
			parse(dateString) {
				return moment(dateString, 'YYYY-MM-DD').toDate();
			},
			i18n: {
				previousMonth: 'Ankstesnis mėnuo',
				nextMonth: 'Kitas mėnuo',
				months: moment.localeData().months(),
				weekdays: moment.localeData().weekdays(),
				weekdaysShort: moment.localeData().weekdaysShort()
			}
		});
	});
}


function tooltipster() {

	if ($(".tooltips").length) {
		$('.tooltips').tooltipster({
			delay: 0,
			position: 'right',
			maxWidth: 242,
		});
	}
}

function fixedHeader() {
	var $header = $('.header-container');
	var $mobileHeader = $('.mobile-header');
	var scrollDirection = 'down';

	function handleScroll() {
		var scrollTop = $(window).scrollTop();
		var threshold = 100;

		if (scrollTop > threshold) {
			$header.addClass('header-scrolled');
			$mobileHeader.addClass('mobile-header-scrolled');
		} else {
			$header.removeClass('header-scrolled');
			$mobileHeader.removeClass('mobile-header-scrolled');
		}

		if (scrollTop > threshold * 3) {
			if (scrollDirection === 'down') {
				$header.addClass('scroll-up');
				$mobileHeader.addClass('scroll-up');
				scrollDirection = 'up';
			}
		} else {
			if (scrollDirection === 'up') {
				$header.removeClass('scroll-up');
				$mobileHeader.removeClass('scroll-up');
				scrollDirection = 'down';
			}
		}
	}

	// Attach scroll event listener
	$(window).on('scroll', handleScroll);

	// Call the scroll handler once to initialize the header state
	handleScroll();
}

function equalHeight() {
	window.addEventListener('load', function () {
		if (isDesktop()) {
			setEqualHeight();
			window.addEventListener('resize', setEqualHeight);
		}
	});

	function isDesktop() {
		// Define the screen width breakpoint for desktop devices
		var desktopWidth = 1024;

		// Check if the current screen width is greater than or equal to the desktop breakpoint
		return window.innerWidth >= desktopWidth;
	}

	function setEqualHeight() {
		var elements = document.getElementsByClassName('equalheight');
		var maxHeight = 0;

		// Reset the heights
		Array.from(elements).forEach(function (element) {
			element.style.height = 'auto';
		});

		// Find the maximum height
		Array.from(elements).forEach(function (element) {
			var height = element.offsetHeight;
			if (height > maxHeight) {
				maxHeight = height;
			}
		});

		// Set the maximum height to all elements
		Array.from(elements).forEach(function (element) {
			element.style.height = maxHeight + 'px';
		});
	}
}

function slickSlider() {
	if ($(window).width() < 768) {
		if ($(".cookies_slider").length > 0) {
			var $slider = $('.cookies_slider');
			$slider.slick({
				dots: true,
				arrows: false,
				infinite: false,
				slidesToShow: 1,
			});
		}
	}
	if ($(".news__slider").length > 0) {
		var $slider = $('.news__slider');
		$slider.on('init', function (event, slick) {
			var slideCount = slick.slideCount;
			var slidesToShow = slick.options.slidesToShow;
			if (slideCount > slidesToShow) {
				$slider.addClass('activated');
			} else {
				$slider.removeClass('activated');
			}
		});

		$slider.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,

			responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 475,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
		if ($slider.hasClass('activated')) {

		} else {
			$('.slider-nav').remove();
		}

		if ($slider.hasClass('activated')) {
			$('.news .slider-nav .prev').click(function () {
				$slider.slick('slickPrev');
			});
		}

		if ($slider.hasClass('activated')) {
			$('.news .slider-nav .next').click(function () {
				$slider.slick('slickNext');
			});
		}
	}


	if ($(".slideshow-slider").length > 0) {
		$(".slideshow-slider").slick({
			autoplay: true,
			autoplaySpeed: 5000,
			prevArrow: '<em class="icon icon-chevron-left previous"></em>',
			nextArrow: '<em class="icon icon-chevron-right next"></em>',
			infinite: true,
			dots: true,
			fade: true,
			arrows: false,
			slidesToShow: 1,
			adaptiveHeight: false,
			dotsClass: "slick-dots container-fluid global_container",
			responsive: [
				{
					breakpoint: 1024,
					settings: {
					}
				},
				{
					breakpoint: 768,
				},
				{
					breakpoint: 576,
				},
				{
					breakpoint: 475,
				}],
		});
	}

	if ($(".important-links-slider").length > 0) {
		$(".important-links-slider").slick({
			prevArrow: '<button class="mygtukas mygtukas--arrow mygtukas--arrow-left" aria-label="previous"></button>',
			nextArrow: '<button class="mygtukas mygtukas--arrow mygtukas--arrow-right" aria-label="next"></button>',
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 4,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						dots: true
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2,
						dots: true
					}
				},
				{
					breakpoint: 475,
					settings: {
						slidesToShow: 2,
						dots: true
					}
				}],
		});
	}
}

function searchToggle() {
	let body = $('body');
	let btn = $('.search-toggle');
	let formWrapper = $('.top-search-wr');

	btn.click(function () {
		formWrapper.toggleClass("active");
		body.toggleClass("overflow-hidden");
	});

	// Handle clicks outside the formWrapper
	$(document).mouseup(function (e) {
		// If the clicked element is not a child of formWrapper
		if (!formWrapper.is(e.target) && formWrapper.has(e.target).length === 0) {
			formWrapper.removeClass("active");
			body.removeClass("overflow-hidden");
		}
	});
	// Handle ESC key press
	$(document).keyup(function (e) {
		// If ESC key is pressed and the formWrapper is active
		if (e.keyCode === 27 && formWrapper.hasClass("active")) {
			formWrapper.removeClass("active");
			body.removeClass("overflow-hidden");
		}
	});
}

function initEuCookieSettings() {
	$('a.cookies-settings').click(function () {
		$('body').addClass('cookies-not-activated');
		$('#eucookie_dialog').removeClass('activated');
	})
}

function mobileMenuInsideToggler() {
	var menuBottom = $('.mobile_menu_parent .menu_bottom > ul > li > a')

	menuBottom.click(function () {
		$(this).next('ul.menu-list').toggle()
	})
}

function dragAndDropFiles() {
	const dragContainers = document.querySelectorAll('.drag-container');

	dragContainers.forEach((dragContainer) => {
		const fileInput = dragContainer.querySelector('input[type="file"]');
		const fileList = dragContainer.querySelector('.fileList');
		let selectedFiles = [];

		dragContainer.addEventListener('dragover', (e) => {
			e.preventDefault();
			dragContainer.classList.add('dragover');
		});

		dragContainer.addEventListener('dragleave', () => {
			dragContainer.classList.remove('dragover');
		});

		dragContainer.addEventListener('drop', (e) => {
			e.preventDefault();
			dragContainer.classList.remove('dragover');
			const files = e.dataTransfer.files;
			handleFiles(files);
		});

		fileInput.addEventListener('change', (e) => {
			const files = e.target.files;
			handleFiles(files);
		});

		function handleFiles(files) {
			if (fileInput.multiple) {
				for (const file of files) {
					selectedFiles.push(file);
				}
			} else {
				selectedFiles = files.length > 0 ? [files[0]] : [];
			}

			updateFileList();
		}

		function updateFileList() {
			fileList.innerHTML = '';
			for (const file of selectedFiles) {
				const fileEntry = createFileEntry(file);
				fileList.appendChild(fileEntry);
			}
		}

		function createFileEntry(file) {
			const fileEntry = document.createElement('div');
			fileEntry.classList.add('file-entry');

			const fileName = document.createElement('span');
			fileName.textContent = file.name;
			fileEntry.appendChild(fileName);

			const deleteButton = document.createElement('div');
			deleteButton.classList.add('delete-button');
			deleteButton.textContent = 'Delete';
			deleteButton.addEventListener('click', () => {
				selectedFiles = selectedFiles.filter((selectedFile) => selectedFile !== file);
				updateFileList();
			});
			fileEntry.appendChild(deleteButton);

			return fileEntry;
		}
	});
}

// JavaScript code for submenu toggling
function toggler() {
// JavaScript code for submenu toggling
	// Get all submenu links with a class of "has-childs"
	const submenuLinks = document.querySelectorAll(".submenu__a.has-childs");

	// Loop through each submenu link
	submenuLinks.forEach((link) => {
		// Get the .icon element within the submenu link
		const icon = link.querySelector(".icon");

		// Add a click event listener to the icon
		icon.addEventListener("click", function (event) {
			// Prevent the default click behavior of the icon
			event.preventDefault();

			// Toggle the "opened" class for the parent submenu link
			link.classList.toggle("active");

			// Get the submenu list associated with this link
			const submenuList = link.nextElementSibling;

			// Toggle the "active" class for the submenu list
//			submenuList.classList.toggle("active");
		});
	});

}

function dukToggle() {
    var items = $('.duk__list .duk__item');
    var half = Math.ceil(items.length / 2);

    var firstHalf = items.slice(0, half);
    var secondHalf = items.slice(half);

    var firstWrapper = $('<div class="wrapper"></div>');
    var secondWrapper = $('<div class="wrapper"></div>');

    firstHalf.wrapAll(firstWrapper);
    secondHalf.wrapAll(secondWrapper);

    var questionWrappers = document.querySelectorAll('.duk__item.toggleable .question-wrapper');

    questionWrappers.forEach(function (questionWrapper) {
        questionWrapper.addEventListener('click', function () {
            var isActive = this.parentElement.classList.contains('active');

            // Deactivate all items first
            items.removeClass('active');

            // If the clicked item wasn't active, activate it
            if (!isActive) {
                this.parentElement.classList.add('active');
            }
        });
    });
}